export const legacyForm = {
  name: 'onify:legacy-form',
  extends: 'onify:legacy',
  cssPath: 'css/legacy-form',
  // Don't include file extension of css or sass file
  vuetify: {
    defaults: {
      VTextField: {
        variant: 'outlined',
        density: 'compact',
        rounded: '0',
        persistentHint: true,
      },
      VSelect: {
        variant: 'outlined',
        density: 'compact',
        rounded: '0',
        persistentHint: true,
      },
      VFileInput: {
        variant: 'outlined',
        density: 'compact',
        rounded: '0',
        persistentHint: true,
      },
      VTextarea: {
        variant: 'outlined',
        density: 'compact',
        rounded: '0',
        persistentHint: true,
      },
      VAutocomplete: {
        variant: 'outlined',
        density: 'compact',
        rounded: '0',
        persistentHint: true,
      },
      VBtn: {
        variant: 'elevated',
        size: 'large',
      },
    },
  },
};
